import { Theme } from '@mui/material';
import { SxProps, SystemStyleObject } from '@mui/system';

export const styles = {
  dialog: (dialogSx: SxProps<Theme>) => ({
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '100%',
        ...(dialogSx as SystemStyleObject<Theme>),
      },
    },
  }),
  header: {
    padding: '40px 40px 20px 40px',
    borderBottom: '1px solid #F3F4F9',
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  heading: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
    textTransform: 'capitalize',
  },
  subheading: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '146%',
    color: '#6e707a',
    textTransform: 'capitalize',
  },
  content: {
    height: '100%',
    padding: '20px 40px',
  },
  footer: {
    padding: '0 40px 20px 40px',
  },
};
